export default "__VITE_PUBLIC_ASSET__437f2b4a__"